
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.188 4.844a2.906 2.906 0 115.812 0v21.312a2.906 2.906 0 11-5.813 0v-.414C21 23.337 16.489 22.17 11.796 21.706l.785 5.254a1.936 1.936 0 01-1.904 2.296H9.614a1.938 1.938 0 01-1.775-1.16l-3.584-6.762-.392-.006A3.902 3.902 0 010 17.438v-3.875a3.914 3.914 0 013.86-3.9c1.604-.022 3.208-.07 4.81-.146 5.896-.298 11.912-1.645 16.518-4.26v-.413zm1.937 0v21.312a.968.968 0 101.938 0V4.844a.969.969 0 00-1.938 0zm-1.938 2.615c-4.541 2.335-10.092 3.57-15.5 3.94v8.2c.35.02.696.043 1.04.07 4.976.367 9.869 1.442 14.46 3.862V7.459zM7.75 19.501v-8.002c-1.286.047-2.573.08-3.86.1a1.976 1.976 0 00-1.953 1.963v3.876c0 1.065.868 1.94 1.95 1.954 1.288.015 2.576.052 3.863.109zM6.477 21.39l3.117 5.884.02.047h1.062l-.004-.027-.859-5.747c-1.111-.067-2.223-.12-3.336-.159v.002z","fill":"#3B3B3B"}})])
          )
        }
      }
    